var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.$store.state.menuType,attrs:{"id":"app-container"}},[_c('topnav'),_c('sidebar'),_c('main',[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }